import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { UserProfile } from "./users/UserProfile";

export interface Props extends RouteComponentProps<{ userEmail: string }> {}

export class AdminUserProfile extends Component<Props, {}> {
  render() {
    return (
      <UserProfile
        isAdminMode={true}
        history={this.props.history}
        location={this.props.location}
        match={this.props.match}
      />
    );
  }
}
